<template>
    <div v-loading="loading" element-loading-text="请稍等···">
        <div class="margin-20">
            <FilterPageList ref="pageListRef" :data="oauthClientConfigList" :total="total" :order-by="orderBy" :filters="filters">
                <template slot-scope="scope">
                    <el-form :inline="true" class="table-filter">
                        <input type="text" v-show="false"/>
<!--                        <el-form-item label="">-->
<!--                            <el-select clearable v-model="backFilter.roleKey">-->
<!--                                <el-option v-for="item in roles" :label="item.roleName" :value="item.roleKey" :key="item.roleKey"></el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="">-->
<!--                            <el-input placeholder="请输入用户名" v-model="backFilter.userName" @keyup.enter.native="getUserRolesReq"></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item label="">
                            <el-input placeholder="请输入appKey" v-model="backFilter.appKey" ></el-input>
                        </el-form-item>
                        <el-form-item label="">
                            <el-input placeholder="请输入应用Id" v-model="backFilter.appId" ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="getOauthClientConfig">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="page-table">
                        <div class="page-table-header">
                            <div class="page-table-header-title"><i class="fa fa-list"></i>OauthClient配置列表
                                <el-button type="text" @click="getOauthClientConfig"><i class="fa fa-refresh"></i></el-button>
                            </div>
                            <div class="pull-right">
                                <el-button @click="handleAdd()"><i class="fa fa-plus-circle text-btn"></i>添加</el-button>
                            </div>
                        </div>
                        <el-table stripe border @sort-change="scope.onSortChange" :data="scope.pageData" style="width: 100%">
                            <el-table-column prop="appId" label="应用Id" >
                                <template slot-scope="scope">
                                    {{scope.row.appId}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="appKey" label="应用Key">
                                <template slot-scope="scope">
                                    {{scope.row.appKey}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="adminName" label="管理员用户名">
                                <template slot-scope="scope">
                                    {{scope.row.adminName}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="adminPassword" label="管理员密码">
                                <template slot-scope="scope">
                                    {{scope.row.adminPassword}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="extJson" label="扩展参数">
                                <template slot-scope="scope">
                                    {{scope.row.extJson}}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100px" align="center">
                                <template slot-scope="scope">
                                    <el-tooltip content="编辑" placement="top">
                                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)"></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="删除" placement="top">
                                        <el-button type="text" icon="el-icon-delete text-danger" @click="handleDelete(scope.row)"></el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </template>
            </FilterPageList>
            <div v-if="isOauthClientVisible">
                <oauth-client-config-dialog :oauth-client-info="oauthClientInfo" :oauth-client-title="oauthClientTitle" :oauth-client-operate="oauthClientOperate" @oauth-client-success="oauthClientSuccess" @close-dialog="closeInfoDialog"></oauth-client-config-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import oauthClientConfigDialog from './oauth_client_config_dialog';

export default {
  data() {
    return {
      loading: false,
      isOauthClientVisible: false,
      oauthClientInfo: {},
      oauthClientTitle: '',
      oauthClientOperate: '',
      oauthClientConfigList: [],
      total: 0,
      filters: {},
      backFilter: {
        appKey: null,
        appId: null,
      },
      orderBy: '',
    };
  },
  methods: {
    handleAdd() {
      this.isOauthClientVisible = true;
      this.oauthClientTitle = '添加OauthClient配置';
      this.oauthClientOperate = 'add';
      const oauthClientAddInfo = {
        appId: '',
        appKey: '',
        adminName: '',
        adminPassword: '',
        extJson: '',
      };
      this.oauthClientInfo = JSON.parse(JSON.stringify(oauthClientAddInfo));
    },
    handleEdit(row) {
      this.isOauthClientVisible = true;
      this.oauthClientTitle = '编辑OauthClient配置';
      this.oauthClientOperate = 'edit';
      const oauthClientEditInfo = {
        id: row.id,
        appId: row.appId,
        appKey: row.appKey,
        adminName: row.adminName,
        adminPassword: '',
        extJson: row.extJson,
      };
      this.oauthClientInfo = JSON.parse(JSON.stringify(oauthClientEditInfo));
    },
    oauthClientSuccess() {
      this.isOauthClientVisible = false;
      this.getOauthClientConfig();
      this.$message.successNotify('保存OauthClient配置操作成功');
    },
    closeInfoDialog() {
      this.isOauthClientVisible = false;
    },
    handleDelete(row) {
      this.$message.confirmMessage(`确认删除 ${row.appId} 吗?`, () => {
        const params = {
          id: row.id,
        };
        this.$http.post('/console/configs/oauthClient/delete', params).then(() => {
          this.getOauthClientConfig();
          this.$message.successNotify('删除OauthClient配置操作成功');
        })
        .catch(() => { this.$http.buildErrorHandler('删除OauthClient配置请求失败！'); });
      });
    },
    getOauthClientConfig() {
      const params = {
        appKey: this.backFilter.appKey !== '' ? this.backFilter.appKey : null,
        appId: this.backFilter.appId !== '' ? this.backFilter.appId : null,
      };
      this.loading = true;
      this.$http.get('/console/configs/oauthClient', params).then((data) => {
        this.oauthClientConfigList = data.oauthClientConfigPage;
        this.total = data.totalCount;
      })
      .catch(() => { this.$http.buildErrorHandler('获取OauthClient配置列表请求失败！'); })
      .finally(() => {
        this.loading = false;
      });
    },
  },
  computed: {
  },
  components: {
    'oauth-client-config-dialog': oauthClientConfigDialog,
  },
  created() {
    this.getOauthClientConfig();
  },
};
</script>
<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// oauth_client_config.vue?6bd979a2